module.exports = __webpack_public_path__ + "static/media/Group_552.402ee80e.png";